<template>
  <v-card>
    <v-card-title primary-title class="py-2">
      <v-toolbar-title>{{ $t("view.commons.filters.title") }}</v-toolbar-title>
      <v-spacer />
      <v-btn icon style="margin: 0" @click="view.elem.datatable.visible = !view.elem.datatable.visible">
        <v-icon>{{ view.elem.datatable.visible ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
      </v-btn>
    </v-card-title>
    <v-expand-transition>
      <v-card-text v-show="view.elem.datatable.visible" class="py-0">
        <v-layout row wrap>
          <v-flex md12>
            <filters ref="filters" @filter="filter" />
          </v-flex>
          <v-flex md12>
            <v-data-table
              ref="dataTable"
              item-key="fechaalta"
              class="monitorCorreos dataTable"
              sort-by="fechaalta"
              :sort-desc="true"
              :headers="view.elem.datatable.headers"
              :items="view.elem.datatable.data"
              :loading="view.elem.datatable.loading"
              :footer-props="view.elem.datatable.footerprops"
              :must-sort="true"
              :server-items-length="view.elem.datatable.total"
              :options.sync="options">
              <template #top>
                <v-text-field v-model.trim="search" dense hide-details :label="$t('view.commons.search')" append-icon="mdi-magnify" />
              </template>
              <template #item.fechaalta="{ item }">
                <em
                  class="btn_tippy"
                  :class="MCORR_STATUS_TABLE[item.estatus].icon"
                  :title="MCORR_STATUS_TABLE[item.estatus].name"
                  :style="`color:${MCORR_STATUS_TABLE[item.estatus].color};`" />
                &nbsp;
                {{ formatDateTime(item.fechaalta) }}
              </template>
              <template #item.fechaEnvio="{ item }">
                {{ formatDateTime(item.fechaEnvio) }}
              </template>
              <template #item.para="{ item }">
                {{ item.para ? item.para.replaceAll(";", ";&nbsp;") : "" }}
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-expand-transition>
  </v-card>
</template>
<script>
import CorreoAPI from "@/services/bitacoras/correo"; /** *******************************/
import Filters from "@/views/bitacoras/monitorCorreos/Filters"; /** *******************************/
import tippy from "tippy.js";
import transform from "@/helpers/server-side-datatable";
import { formatDateTime } from "@/helpers/date-methods";
import { MCORR_STATUS_TABLE } from "@/constants/operativos";

export default {
  components: { Filters }
  , data() {
    return {
      options: {}
      , filtros: {}
      , search: ""
      , timer: undefined
      , MCORR_STATUS_TABLE
      , view: {
        elem: {
          datatable: {
            visible: true
            , loading: false
            , data: []
            , total: 0
            , footerprops: { showFirstLastPage: true, "items-per-page-options": [10, 25, 50, 100] }
            , headers: [
              { text: this.$t("view.bitacoras.monitorCorreos.form.fechaalta.th"), align: "center", sortable: true, class: "fechaalta", cellClass: "fechaalta", value: "fechaalta" }
              , { text: this.$t("view.bitacoras.monitorCorreos.form.fechaEnvio.th"), align: "center", sortable: true, class: "fechaEnvio", cellClass: "fechaEnvio", value: "fechaEnvio" }
              , { text: this.$t("view.bitacoras.monitorCorreos.form.de.th"), align: "left", sortable: true, class: "de", cellClass: "de", value: "de" }
              , { text: this.$t("view.bitacoras.monitorCorreos.form.para.th"), align: "left", sortable: true, class: "para", cellClass: "para", value: "para" }
              , { text: this.$t("view.bitacoras.monitorCorreos.form.asunto.th"), align: "left", sortable: true, class: "asunto", cellClass: "asunto", value: "asunto" }
            ]
          }
        }
      }
    };
  }
  , watch: {
    options: {
      handler() {
        this.load();
      }
      , deep: true
    }
    , search: {
      handler() {
        this.options.page = 1;
        this.load();
      }
      , deep: true
    }
  }
  , created() {
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      this.load();
    }, 1000 * 10);
  }
  , destroyed() {
    if (this.timer) clearInterval(this.timer);
  }
  , updated() {
    tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
  }
  , methods: {
    prepareData() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      let serverSideData = {};
      serverSideData.draw = "0";
      serverSideData.filters = JSON.stringify(this.filtros);
      serverSideData.start = page;
      serverSideData.length = itemsPerPage;
      serverSideData.search = { value: this.search ? this.search : "", regex: false };
      serverSideData.order = { column: sortBy, dir: sortDesc };
      serverSideData.columns = this.view.elem.datatable.headers;
      return transform.transformServerSideRequest(serverSideData);
    }
    , async load() {
      if (!this.filtros || this.filtros == {}) return false;

      this.view.elem.datatable.loading = true;

      const serverSideDataT = this.prepareData();
      const response = await CorreoAPI.list(serverSideDataT);
      const { data, recordsTotal } = response.data;

      this.view.elem.datatable.data = data;
      this.view.elem.datatable.total = Number(recordsTotal);

      this.view.elem.datatable.loading = false;
    }
    , async filter(filters) {
      let fls = { ...filters };
      Object.keys(fls).forEach(function (key) {
        if (fls[key].length > 0) {
          fls[key] = fls[key].join();
        } else {
          delete fls[key];
        }
      });
      this.filtros = fls;
      this.options.page = 1;
      this.load();
    }
    , formatDateTime
  }
};
</script>



// WEBPACK FOOTER //
// src/views/bitacoras/monitorCorreos/DataTable.vue